(function () {
  'use strict';

  const section = document.querySelector('[data-section-type="mc2026-collection-page"]');
  if (!section) return;

  const grid = document.getElementById('mc2026-product-grid');

  function applyFilterUrl(url) {
    fetch(url)
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('#mc2026-product-grid');
        if (newGrid && grid) {
          grid.innerHTML = newGrid.innerHTML;
          initCards();
          initInfiniteScroll();
        }
        window.history.pushState({}, '', url);
      });
  }

  function initSizePills() {
    section.querySelectorAll('.mc2026-size-pill').forEach(pill => {
      pill.addEventListener('click', function () {
        if (this.classList.contains('mc2026-size-pill--unavailable')) return;
        const isActive = this.dataset.active === 'true';
        const url = isActive ? this.dataset.urlRemove : this.dataset.urlAdd;
        section.querySelectorAll('.mc2026-size-pill').forEach(p => {
          p.classList.remove('mc2026-size-pill--active');
          p.setAttribute('aria-pressed', 'false');
          p.dataset.active = 'false';
        });
        if (!isActive) {
          this.classList.add('mc2026-size-pill--active');
          this.setAttribute('aria-pressed', 'true');
          this.dataset.active = 'true';
        }
        applyFilterUrl(url);
      });
    });
  }

  function initFilterDrawer() {
    const drawer = document.getElementById('mc2026-filter-drawer');
    const trigger = section.querySelector('.mc2026-filter-trigger');
    const closeButtons = section.querySelectorAll('.mc2026-filter-drawer__close');
    const overlay = drawer && drawer.querySelector('.mc2026-filter-drawer__overlay');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (trigger) trigger.addEventListener('click', openDrawer);
    closeButtons.forEach(btn => btn.addEventListener('click', closeDrawer));
    if (overlay) overlay.addEventListener('click', closeDrawer);

    section.querySelectorAll('.mc2026-filter-group__title').forEach(btn => {
      btn.addEventListener('click', function () {
        const isOpen = this.getAttribute('aria-expanded') === 'true';
        const body = document.getElementById(this.getAttribute('aria-controls'));
        this.setAttribute('aria-expanded', String(!isOpen));
        if (body) body.classList.toggle('is-open', !isOpen);
      });
    });

    section.querySelectorAll('.mc2026-filter-checkbox').forEach(checkbox => {
      checkbox.addEventListener('change', function () {
        const url = this.checked ? this.dataset.urlAdd : this.dataset.urlRemove;
        applyFilterUrl(url);
      });
    });
  }

  function getVariants(card) {
    try {
      return JSON.parse(card.dataset.variants || '[]');
    } catch(e) {
      return [];
    }
  }

  function buildSizes(card, variants, activeColour) {
    const sizeWrap = card.querySelector('.mc2026-product-card__sizes');
    const atc = card.querySelector('.mc2026-product-card__atc');
    if (!sizeWrap || !atc) return;

    sizeWrap.innerHTML = '';
    atc.textContent = 'Select a size';
    atc.disabled = true;
    atc.className = 'mc2026-product-card__atc';
    atc.dataset.variantId = '';

    const filtered = activeColour
      ? variants.filter(v => v.colour === activeColour)
      : variants;

    filtered.forEach(v => {
      const label = v.size || v.colour || 'One size';
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = label;
      btn.className = 'mc2026-size-option' + (!v.available ? ' mc2026-size-option--soldout' : '');

      if (v.available) {
        btn.addEventListener('click', function () {
          sizeWrap.querySelectorAll('.mc2026-size-option').forEach(b => b.classList.remove('mc2026-size-option--active'));
          this.classList.add('mc2026-size-option--active');
          atc.textContent = 'Add to cart';
          atc.disabled = false;
          atc.dataset.variantId = String(v.id);
        });
      }

      sizeWrap.appendChild(btn);
    });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart } }));
        const cartCountEls = document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count');
        cartCountEls.forEach(el => { el.textContent = cart.item_count; });
      });
  }

  function initAtc(card) {
    const atc = card.querySelector('.mc2026-product-card__atc');
    if (!atc) return;

    atc.addEventListener('click', function () {
      const variantId = parseInt(this.dataset.variantId);
      if (!variantId || this.disabled) return;

      const originalText = this.textContent;
      this.textContent = 'Adding...';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1, sections: 'cart-notification' })
      })
      .then(r => r.json())
      .then(data => {
        if (data.status && data.status !== 200) {
          this.textContent = data.description || 'Error';
          this.disabled = false;
          return;
        }
        this.textContent = 'Added!';
        this.classList.add('mc2026-product-card__atc--added');
        refreshCart();
        setTimeout(() => {
          this.textContent = originalText;
          this.classList.remove('mc2026-product-card__atc--added');
          this.disabled = false;
        }, 2500);
      })
      .catch(() => {
        this.textContent = 'Error — try again';
        this.disabled = false;
      });
    });
  }

  function initCards() {
    grid.querySelectorAll('.mc2026-product-card').forEach(card => {
      const variants = getVariants(card);
      if (!variants.length) return;

      const firstColour = variants[0].colour || '';
      buildSizes(card, variants, firstColour);
      initAtc(card);

      card.querySelectorAll('.mc2026-swatch').forEach(swatch => {
        swatch.addEventListener('click', function () {
          card.querySelectorAll('.mc2026-swatch').forEach(s => s.classList.remove('mc2026-swatch--active'));
          this.classList.add('mc2026-swatch--active');
          const img = this.dataset.img;
          const cardImg = card.querySelector('.mc2026-product-card__image');
          if (cardImg && img) cardImg.src = img;
          buildSizes(card, variants, this.dataset.colour);
        });
      });
    });
  }

  function initInfiniteScroll() {
    const sentinel = document.querySelector('.mc2026-infinite-sentinel');
    if (!sentinel) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        const nextUrl = sentinel.dataset.nextUrl;
        if (!nextUrl) return;
        fetch(nextUrl)
          .then(r => r.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newItems = doc.querySelectorAll('.mc2026-product-card');
            const newSentinel = doc.querySelector('.mc2026-infinite-sentinel');
            sentinel.remove();
            newItems.forEach(item => grid.appendChild(item));
            if (newSentinel) grid.appendChild(newSentinel);
            initCards();
            initInfiniteScroll();
          });
      });
    }, { rootMargin: '300px' });

    observer.observe(sentinel);
  }

  initSizePills();
  initFilterDrawer();
  initCards();
  initInfiniteScroll();

})();